import { call, put, takeLatest } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/costs/actions';
import {
  fetchCosts as fetchCostsApi,
} from '../../api/costs';

export function* fetchCosts(actions) {
  try {
    const response = yield call(fetchCostsApi, actions.payload);
    let responseData = response.data;
    if (responseData && responseData.status === "200") {
      yield put(Creators.fetchCostsSuccess(responseData));
    }
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.fetchCostsFailure(error_message));
  }
}

export function* watchFetchCosts() {
  yield takeLatest(Types.FETCH_COSTS, fetchCosts);
}
